<div>
    <div class="row">
        <div class="col">
            <h3>{{ 'Reklamationer' | translate }}</h3>
        </div>
        <div class="col align-right">
            <mat-form-field appearance="fill">
                <mat-label>{{ 'Period' | translate }}</mat-label>
                <mat-date-range-input [rangePicker]="picker">
                    <input matStartDate [placeholder]="'Startdatum' | translate" [(ngModel)]="periodStart">
                    <input matEndDate [placeholder]="'Slutdatum' | translate" [(ngModel)]="periodEnd">
                </mat-date-range-input>
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-date-range-picker #picker></mat-date-range-picker>
            </mat-form-field>
            <br />
        </div>
    </div>

    <table class="fullwidth styled" *ngIf="reclaimedOrders">
        <tr>
            <th>#</th>
            <th>{{ 'Order skapad' | translate }}</th>
            <th>{{ 'Orsak' | translate }}</th>
            <th>{{ 'Beskrivning' | translate }}</th>
        </tr>
        <tr *ngFor="let order of reclaimedOrders">
            <td>
                {{order.orderNumber}}
            </td>
            <td>{{order.created | date: 'yyyy-MM-dd HH:mm'}}</td>
            <td>
                <span *ngIf="order.metadata.reclaimBlame == 'CUSTOMER'">{{ 'Slutkund' | translate }}</span>
                <span *ngIf="order.metadata.reclaimBlame == 'PARTNER'">{{ 'Partner' | translate }}</span>
                <span *ngIf="order.metadata.reclaimBlame == 'ACE'">ACE</span>
                <span *ngIf="order.metadata.reclaimBlame == 'DELIVERY'">{{ 'Fraktbolag' | translate }}</span>
                <span *ngIf="order.metadata.reclaimBlame == 'PRINT_PARTNER'">{{ 'Exakta' | translate }}</span>
            </td>
            <td>{{order.metadata.reclaimDescription}}</td>
        </tr>
    </table>
</div>